<template>
	<div class="model-container">
		<div class="model-container-close" @click="bus.event = null"></div>
		<bb-3dviewer id="3dviewer" :sku="item.code"></bb-3dviewer>
	</div>
</template>

<script setup>
	const {bus} = useEventBus();
	const config = useAppConfig();
	const props = defineProps(['item']);

	onMounted(()=>{
		const viewer = document.getElementById("3dviewer");
		const qrUrl = config.host == 'https://www.bigbang.si' ? 'https://bb.4th.vision/prod/index.html?sku=' : 'https://bb.4th.vision/test/index.html?sku=';
		viewer.addEventListener("error", (error) => {
			console.log("error", error);
		});
		viewer.addEventListener("load", (event) => {
			console.log("load", event.detail.loaded);
		});
		viewer.setAttribute("qr-url", qrUrl + props.item.code);
	})
</script>

<style lang="less" scoped>
	.model-container{display: flex; align-items: center; width: 100%; height: 100vh; background: @white; position: fixed; top: 0; bottom: 0; left: 0; right: 0; z-index: 111111;}

	.model-container-close{
		display: flex; align-items: center; justify-content: center; width: 50px; height: 50px; background: @red; position: absolute; top: 5%; right: 3%; cursor: pointer; .transition(all); z-index: 111;
		&:before{.icon-x(); font: 22px/1 @fonti; color: @white; position: absolute;}
		@media (min-width: @t){
			&:hover{opacity: 0.8;}
		}

		@media (max-width: @t){top: 30px; right: 30px;}
		@media (max-width: @ms){
			width: 44px; height: 44px; top: 15px; right: 5%;
			&:before{font-size: 18px;}
		}
	}
</style>
